import Agencies from 'routes/Agencies'

export default Agencies
